import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Unauthenticated API client for public read-only endpoints (template listing, etc.). */
export const publicApi = axios.create({
  baseURL: `${API_URL}/api`,
});

/** Resolve list-API thumbnail paths to absolute URLs for <img src>. */
export function resolveThumbnailUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith('http') || pathOrUrl.startsWith('data:')) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${API_URL}${path}`;
}
